var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapDestinationPointMoved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20 39C20 38.4477 20.4477 38 21 38H40C40.5523 38 41 38.4477 41 39C41 39.5523 40.5523 40 40 40H21C20.4477 40 20 39.5523 20 39Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39C18 37.3431 19.3431 36 21 36C22.6569 36 24 37.3431 24 39C24 40.6569 22.6569 42 21 42C19.3431 42 18 40.6569 18 39Z",
    fill: "#2F2F32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39C19 37.8954 19.8954 37 21 37C22.1046 37 23 37.8954 23 39C23 40.1046 22.1046 41 21 41C19.8954 41 19 40.1046 19 39Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 39C20 38.4477 20.4477 38 21 38C21.5523 38 22 38.4477 22 39C22 39.5523 21.5523 40 21 40C20.4477 40 20 39.5523 20 39Z",
    fill: "#4D65F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18H20V0H40C41.1046 0 42 0.895431 42 2V16C42 17.1328 41.0841 17.9429 40 18Z",
    fill: "#2F2F32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 18,
    height: 14,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V27C22 27.5523 21.5523 28 21 28C20.4477 28 20 27.5523 20 27V0Z",
    fill: "#4D65F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14H26V12H28V14Z",
    fill: "#414146"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14H30V12H32V14Z",
    fill: "#414146"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36 14H34V12H36V14Z",
    fill: "#414146"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H24V10H26V12Z",
    fill: "#414146"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12H28V10H30V12Z",
    fill: "#414146"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34 12H32V10H34V12Z",
    fill: "#414146"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 12H36V10H38V12Z",
    fill: "#414146"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10H26V8H28V10Z",
    fill: "#414146"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10H30V8H32V10Z",
    fill: "#414146"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10H34V8H36V10Z",
    fill: "#414146"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H24V6H26V8Z",
    fill: "#414146"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30 8H28V6H30V8Z",
    fill: "#414146"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34 8H32V6H34V8Z",
    fill: "#414146"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38 8H36V6H38V8Z",
    fill: "#414146"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H26V4H28V6Z",
    fill: "#414146"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6H30V4H32V6Z",
    fill: "#414146"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36 6H34V4H36V6Z",
    fill: "#414146"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDestinationPointMoved);
export default __webpack_public_path__ + "static/media/map_destination_point_moved.fb1404a90abfe4f308a503d9ed07853e.svg";
export { ForwardRef as ReactComponent };